<!---- Copyright The Linux Foundation and each contributor to LFX.-->
<!---- SPDX-License-Identifier: MIT -->
<div class="offcanvas-container">
  <div class="close-button-box cursor-pointer" (click)="close()" aria-label="Close repository details">
      <i class="fal fa-times"></i>
  </div>

  <h2 class="platform-groups-title">Repo Activity</h2>

    <div class="platform-groups">
      <div class="platform-group" *ngFor="let group of platformGroups">
        <h3 class="platform-title">
          <img ngbTooltip="{{ group.platform | titlecase }}" tooltipClass="lf-box-tooltip" [src]="group.icon" alt="Platform Icon" class="platform-icon" width="24" height="24">
          {{ group.repos.length }} {{ group.repos.length === 1 ? 'repo' : 'repos' }}
        </h3>
        <ul class="repo-list">
          <li class="repo-item" *ngFor="let repo of group.repos">
            <a *ngIf="repo.repositoryUrl" [href]="repo.repositoryUrl" class="lf-link-v2" target="_blank" rel="noopener noreferrer">
              /{{ repo.repoName | ellipsis: 21 }}
            </a>
            <span *ngIf="!repo.repositoryUrl">
              /{{ repo.repoName | ellipsis: 21 }}
            </span>
          </li>
        </ul>
      </div>
    </div>

    <lfx-section-footer></lfx-section-footer>
</div>

